import LineCompassIcon from 'LuxKit/Icons/line/LineCompassIcon'
import TextLink from 'LuxKit/TextLink'
import React, { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import AdditionalWaysToExperienceMessagingTile from './AdditionalWaysToExperienceMessagingTile'
import ModalContext from 'contexts/ModalContext'
import PrivateRequestFormModal from 'components/OfferPage/TourV2/PrivateRequest/PrivateRequestFormModal'
import type { OfferPageRoom } from 'contexts/OfferPage/offerPageStateReducer'

interface Props {
  offer: App.Tours.TourV2Offer
  defaultTravellers: Array<OfferPageRoom>
}

function PrivateDepartureMessagingTile({ offer, defaultTravellers }: Props) {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const requestPrivateTour = useCallback(() => {
    showModal(<PrivateRequestFormModal offer={offer} defaultTravellers={defaultTravellers} />)
  }, [showModal, offer, defaultTravellers])

  return <AdditionalWaysToExperienceMessagingTile
    heading={intl.formatMessage({
      id: 'fwUZiSPlyT',
      defaultMessage: 'Private Departure',
      description: 'Section heading for private departure messaging tile',
    })}
    description={intl.formatMessage({
      id: 'xfM9n9vAAu',
      defaultMessage: 'Travel exclusively with family and friends at a time that works best for you.',
      description: 'Description for private departure messaging tile in the tours section',
    })}
    Icon={LineCompassIcon}
    action={<TextLink size="small" onClick={requestPrivateTour}>{intl.formatMessage({
      id: 'tm6C1PvEMR',
      defaultMessage: 'Submit a request',
      description: 'Hyperlink text to submit a private departure request',
    })}
    </TextLink>}
  />
}

export default PrivateDepartureMessagingTile
